/**
 * Ajout pur de ce lot (aucun équivalent apps/web — le Server Component
 * d'origine n'avait pas besoin d'état de chargement/erreur explicite, géré
 * implicitement par Suspense/error.tsx). `useQuery()` expose `isLoading`/
 * `isError` explicitement dans ce SPA : ces deux blocs neutres, réutilisés par
 * toutes les pages boutique/catalogue de ce lot, évitent de dupliquer le même
 * balisage dans chaque page.
 */
export function LoadingBlock({ label = "Chargement…" }: { label?: string }) {
  return (
    <div role="status" className="container-vvs py-16 text-center">
      <p className="font-body text-sm text-muted">{label}</p>
    </div>
  );
}

export function ErrorBlock({
  title = "Impossible de charger cette page pour le moment.",
  message = "Réessayez dans un instant.",
}: {
  title?: string;
  message?: string;
}) {
  return (
    <div className="container-vvs py-16 text-center">
      <p className="font-body text-base text-ink">{title}</p>
      <p className="mt-2 font-body text-sm text-muted">{message}</p>
    </div>
  );
}
